// extracted by mini-css-extract-plugin
export default {"body":"formModal_body__i5Xpz"};